import { Component, OnInit, ViewChild } from '@angular/core';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { TextSearchService } from 'src/app/services/text-search.service';
import { FilterTextRasComponent } from './filter-text-ras/filter-text-ras.component';

@Component({
  selector: 'header-ras-search',
  templateUrl: './header-ras-search.component.html',
  styleUrls: ['./header-ras-search.component.scss'],
})
export class HeaderRasSearchComponent implements OnInit {
  text;
  searchTouch: boolean;
  users = [];
  units;
  search;
  optionTextSearch = ['Casos', 'Tareas'];
  optionSelect;
  @ViewChild('filterTextRasComponent')
  filterTextRasComponent: FilterTextRasComponent;
  constructor(
    public readonly textSearchService: TextSearchService,
    public readonly userService: UserService,
    private readonly unitsService: UnitsService
  ) {}

  ngOnInit() {
    this.textSearchService.filterToHeader.subscribe((res) => {
      this.searchToContent(res);
    });
    this.getUnitType();
  }

  public back() {
    window.history.go(-1);
  }
  lastFilter;
  async searchToContent(filter?) {
    let options;
    if (filter) {
      this.lastFilter = filter;
      options = {
        option: filter.type,
        tipo_caso: filter.caseType ? [filter.caseType] : undefined,
        assigned: filter.assigned,
        date: filter.date,
        end: filter.end,
        beging: filter.beging,
        units: this.userService.currentUser?.role.units,
        text: this.search,
      };
      this.optionSelect = filter.type;
    } else {
      options = {
        units: this.userService.currentUser?.role.units,
        text: this.search,
        option: this.optionSelect,
      };
      if (!this.optionSelect) {
        options.option = this.filterTextRasComponent.form.value.type
          ? this.filterTextRasComponent.form.value.type
          : 'Casos';
        this.optionSelect = this.filterTextRasComponent.form.value.type
          ? this.filterTextRasComponent.form.value.type
          : 'Casos';
      } else if (!filter && this.optionSelect) {
        options.option = this.filterTextRasComponent.form.value.type
          ? this.filterTextRasComponent.form.value.type
          : 'Casos';
        this.optionSelect = this.filterTextRasComponent.form.value.type
          ? this.filterTextRasComponent.form.value.type
          : 'Casos';
      }
    }
    this.textSearchService.filterToPage.next(options);
  }
  changeType(type) {
    this.textSearchService.changeType.next(type);
  }
  getUnitType() {
    let units = this.userService.currentUser?.role.units;
    this.unitsService.getUnitAndCaseType(units).subscribe((res) => {
      this.units = res;
      this.findUser(res);
    });
  }
  async findUser(data) {
    for (let uni of data) {
      for (let typeCase of uni.ct) {
        await this.userService.getUsersByRole(typeCase.role).subscribe({
          next: (users) => {
            this.users = [...this.users, ...users];
          },
        });
      }
    }
  }
}
